"use strict";
exports.__esModule = true;
var React = require("react");
require("./right-anchor.scss");
var stat_1 = require("../stat/stat");
var RightAnchor = function () {
    return (React.createElement("div", { className: "p-header__main__cnt__right__item p-header__main__cnt__right__item--anchor" },
        React.createElement("a", { href: "//www.yy.com/liveguide", className: "p-header__main__cnt__right__item__tl", target: "_blank", rel: "noopener noreferrer", onClick: function () {
                stat_1.stat(stat_1.EStatType.ANCHOR_CLICK);
            } },
            React.createElement("i", { className: "p-header__main__cnt__right__item__tl__icon" }),
            React.createElement("span", { className: "p-header__main__cnt__right__item__tl__t" }, "\u5F00\u64AD"))));
};
exports["default"] = RightAnchor;
